export default "__VITE_ASSET__C1I$TbUA__"